export const logFirebaseAccessError = ({
  error,
  path,
  operation,
  user,
  role,
  companyId,
  projectId,
  context,
}) => {
  const code = error?.code || "";
  const message = error?.message || String(error || "");
  const isPermissionError =
    code === "permission-denied" ||
    message.toLowerCase().includes("missing or insufficient permissions");

  const details = {
    operation,
    path,
    userUid: user?.uid || "",
    userEmail: user?.email || "",
    role: role || "",
    companyId: companyId || "",
    projectId: projectId || "",
    code,
    message,
    context: context || "",
  };

  if (isPermissionError) {
    console.error("Firebase permission denied:", details);
    return;
  }

  console.warn("Firebase access error:", details);
};
